import { render, staticRenderFns } from "./SingleClient.vue?vue&type=template&id=65634d4a&"
import script from "./SingleClient.vue?vue&type=script&lang=js&"
export * from "./SingleClient.vue?vue&type=script&lang=js&"
import style0 from "./SingleClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports